import React from 'react';
import { Sparkles, Flame, ShieldCheck, Layers } from 'lucide-react';
export function FeaturesSection() {
  return <section className="py-24 bg-white" data-id="element-52">
      <div className="container mx-auto px-4" data-id="element-53">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24" data-id="element-54">
          <div data-id="element-55">
            <h2 className="text-4xl md:text-5xl font-serif mb-8 leading-tight" data-id="element-56">
              No es solo ropa. <br data-id="element-57" />
              <span className="text-stone-500 italic" data-id="element-58">
                Es el marco de tu calzado.
              </span>
            </h2>
            <div className="space-y-6 text-lg text-gray-600 leading-relaxed" data-id="element-59">
              <p data-id="element-60">
                ¿Sientes que a tu outfit le falta algo para verse como en
                Pinterest? No es la ropa, es la transición.
              </p>
              <p data-id="element-61">
                Aura Polar elimina ese "espacio vacío" entre tus botas y tus
                piernas con el volumen perfecto.
              </p>
            </div>
          </div>
          <div className="relative h-[600px] bg-stone-100 overflow-hidden" data-id="element-62">
            <img src="https://cdn.magicpatterns.com/uploads/fhi2SusqxkHz25ER4hHAm7/2.webp" alt="Calentadores blancos de piel sintética con botas UGG" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" data-id="element-63" />
          </div>
        </div>

        <div className="text-center mb-16" data-id="element-64">
          <h3 className="text-3xl font-serif mb-4" data-id="element-65">¿Por qué Aura Polar?</h3>
          <div className="w-24 h-1 bg-black mx-auto" data-id="element-66"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-67">
          {/* Feature 1 */}
          <div className="p-8 bg-stone-50 transition-colors duration-300 group" data-id="element-68">
            <div className="mb-6 inline-flex p-3 bg-white rounded-full shadow-sm group-hover:scale-110 transition-transform" data-id="element-69">
              <Sparkles className="w-6 h-6 text-stone-800" data-id="element-70" />
            </div>
            <h4 className="text-xl font-serif font-bold mb-4" data-id="element-71">
              Volumen Editorial
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-72">
              Diseñados para mantener su forma y movimiento, creando esa silueta
              icónica que ves en Pinterest y TikTok.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="p-8 bg-stone-50 transition-colors duration-300 group" data-id="element-73">
            <div className="mb-6 inline-flex p-3 bg-white rounded-full shadow-sm group-hover:scale-110 transition-transform" data-id="element-74">
              <Layers className="w-6 h-6 text-stone-800" data-id="element-75" />
            </div>
            <h4 className="text-xl font-serif font-bold mb-4" data-id="element-76">
              Textura Luxury
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-77">
              Fibra sintética de alta densidad <em data-id="element-78">Cruelty-Free</em>. Se siente
              como lujo, se ve como lujo.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="p-8 bg-stone-50 transition-colors duration-300 group" data-id="element-79">
            <div className="mb-6 inline-flex p-3 bg-white rounded-full shadow-sm group-hover:scale-110 transition-transform" data-id="element-80">
              <Flame className="w-6 h-6 text-stone-800" data-id="element-81" />
            </div>
            <h4 className="text-xl font-serif font-bold mb-4" data-id="element-82">
              Versatilidad Total
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-83">
              Úsalos con UGGs para un look <em data-id="element-84">cozy</em> o con plataformas para
              una vibra <em data-id="element-85">alt-chic</em>.
            </p>
          </div>

          {/* Feature 4 */}
          <div className="p-8 bg-stone-50 transition-colors duration-300 group" data-id="element-86">
            <div className="mb-6 inline-flex p-3 bg-white rounded-full shadow-sm group-hover:scale-110 transition-transform" data-id="element-87">
              <ShieldCheck className="w-6 h-6 text-stone-800" data-id="element-88" />
            </div>
            <h4 className="text-xl font-serif font-bold mb-4" data-id="element-89">
              Calor con Estética
            </h4>
            <p className="text-gray-600 text-sm leading-relaxed" data-id="element-90">
              No sacrifiques tus faldas; añade protección sin perder el estilo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}